import {
  MutationFunction,
  useMutation,
  useQuery,
  useQueryClient
} from "react-query";
import { defaultError, defaultSuccess } from "../../../libs/utils";
import {
  getEventMaterials,
  updateEventMaterial
} from "../../../services/api/eventMaterials";
import {
  approveMaterialRequest,
  deleteMaterialRequest,
  updateMaterialRequest
} from "../../../services/api/materialRequests";
import { MaterialRequest } from "../utils/types";
import { MATERIAL_REQUESTS_ALL_QUERY_KEY } from "./useAllMaterialRequests";
import { MATERIAL_REQUESTS_QUERY_KEY } from "./useCompanyMaterialRequests";

export type DeleteMaterialRequestParams = {
  registrationId: number;
  requestId: number;
};

export const useDeleteMaterialRequest = () => {
  const queryClient = useQueryClient();

  return useMutation(
    ({ registrationId, requestId }: DeleteMaterialRequestParams) => {
      return deleteMaterialRequest(registrationId, requestId);
    },
    {
      onError: (error: any, variables, context) => {
        defaultError(`Failed to delete Material Request: ${error?.message}`);
      },

      onSuccess: (data, variables, context) => {
        defaultSuccess("Material Request Deleted");
        // Boom baby!
        queryClient.invalidateQueries(MATERIAL_REQUESTS_ALL_QUERY_KEY);
        queryClient.invalidateQueries(MATERIAL_REQUESTS_QUERY_KEY);
      }
    }
  );
};
